import * as React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <path
      d="M5 5V21L8 19L10 21L12 19L14 21L16 19L19 21V19.01M7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V15"
      stroke="var(--status-danger)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      transform="translate(-2, -2) scale(1.2)"
    />
    <path
      d="M11 7H15"
      stroke="var(--status-danger)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      transform="translate(-2, -2) scale(1.2)"
    />
    <path
      d="M9 11H11"
      stroke="var(--status-danger)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      transform="translate(-2, -2) scale(1.2)"
    />
    <path
      d="M13 15H15"
      stroke="var(--status-danger)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      transform="translate(-2, -2) scale(1.2)"
    />
    <path
      d="M15 11V11.01"
      stroke="var(--status-danger)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      transform="translate(-2, -2) scale(1.2)"
    />
    <path
      d="M3 3L21 21"
      stroke="var(--status-danger)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      transform="translate(-2, -2) scale(1.2)"
    />
  </React.Fragment>,
  'TicketAutoprintFailed'
)
